export default {
  selfDriving: "self-driving",
  energyVision: "energy-vision",
  smartAgent: "smart-agent",
  technicalAdvisor: "technical-advisor"
};
